import type { RouteRecordRaw } from 'vue-router';
import { HasNavigationLayout } from '@/pages/_layout';

export const vehicleRoutes: RouteRecordRaw[] = [
    {
        path: '/vehicles/select',
        name: 'VehicleSelect',
        component: () => import('@/pages/vehicles/select/VehicleSelect.vue'),
        meta: {
            title: '車両選択',
            requiresAuth: true,
            layout: HasNavigationLayout,
        },
    },
];
